import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutFinanceAccountsRequestModel, PutFinanceAccountsResponseModel } from "@/features/accounts/finance/services/put-accounts-model";

export class PutFinanceAccountsApi {
  /**
   * 銀行口座更新API
   */
  public putFinanceAccounts = async (
    param: PutFinanceAccountsRequestModel
  ): Promise<PutFinanceAccountsResponseModel> => {
    const path = `/api/financeaccounts/finances`;
    const res = await ApiClient.instance.put<PutFinanceAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
